import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css!';

class SliderImplantations {

  constructor(){
    this.component = document.querySelector('[data-component="slider-implantations"]');
    this.trigger = document.querySelector('[data-trigger="slider-implantations"]');
    this.tabs = document.querySelectorAll('[data-tabs="slider-implantations"]');
    this._init();
  }

  _init(){

    if( this.component ){
      this.swiper = null;
        
      const firstImage = this.trigger.querySelector('img');
      if(firstImage){
        firstImage.onload = ()=> {
          if(this.swiper){
            this.swiper.update();
          }
        };
      }

      this.swiper = new Swiper(this.trigger, {
        pagination: {
          el: this.component.querySelector('[data-trigger="slider-implantations-pagination"]'),
          type: 'bullets',
          clickable: true
        },
        navigation: {
          nextEl: this.component.querySelector('[data-trigger="slider-implantations-next"]'),
          prevEl: this.component.querySelector('[data-trigger="slider-implantations-prev"]'),
        },
        preloadImages: false,
        lazy: {
          loadOnTransitionStart: true,
        },
        on: {
          slideChange: this.updateNav.bind(this),
        },
      });

      for (let i=0; i<this.tabs.length; i++) {
        this.tabs[i].addEventListener('click', 
          (event) => this.updateSlider(i, event)
        );
      }
    }
  }

  /**
	 * Change l'état actif de la navigation du carousel
	 * en fonction de l'index de la slide active
	 */
	updateNav(){
		for (let tab of this.tabs) {
      tab.setAttribute('data-state', 'inactive');
    }
    this.tabs[this.swiper.activeIndex].setAttribute('data-state', 'active');
	}

	/**
	 * Change la slide en fonction de l'index passé en paramètre
	 * Change l'état actif de la navigation du carousel en fonction de l'index passé en paramètre
	 */
	updateSlider(index, event){
    for (let tab of this.tabs) {
      tab.setAttribute('data-state', 'inactive');
    }
    event.currentTarget.setAttribute('data-state', 'active');
		this.swiper.slideTo(index);
	}
}

export const sliderImplantations = new SliderImplantations();